export default "__VITE_ASSET__BIwmOwHh__"